import React from 'react';
import { IconProps } from '.';

const SvgBulbOn = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='M14 23.25h-4v-1.5h4v1.5Z' />
      <path
        fill={color}
        fillRule='evenodd'
        d='M12 4.3a7 7 0 0 1 7 7 6.989 6.989 0 0 1-3.25 5.907v3.543h-7.5v-3.543A6.989 6.989 0 0 1 5 11.3a7 7 0 0 1 7-7Zm0 1.5a5.5 5.5 0 0 0-2.25 10.518v2.932h4.5v-2.932A5.5 5.5 0 0 0 12 5.8Z'
        clipRule='evenodd'
      />
      <path
        fill={color}
        d='M3.5 12.25h-2v-1.5h2v1.5ZM22.5 12.25h-2v-1.5h2v1.5ZM6.03 4.47 4.97 5.53l-1.5-1.5 1.06-1.06 1.5 1.5ZM20.53 4.03l-1.5 1.5-1.06-1.06 1.5-1.5 1.06 1.06ZM12.75 2.5h-1.5v-2h1.5v2Z'
      />
    </svg>
  );
};

export default SvgBulbOn;
